import React from "react";

import { Label, Spacer } from "../base";

const Loading = () => (
  <>
    <Spacer size={24} />
    <Label light small>
      Loading...
    </Label>
    <Spacer size={24} />
  </>
);

export default Loading;
